import { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import Header from '../../components/Header/Header'
import { toast } from 'react-hot-toast';
import ReactGA from 'react-ga4';
import{UserContext} from '../../context/userContext/userContext';
import { useStyle } from "../../context/styleContext/styleContext"
import TermsModal from "../Terms/TermsModal";
import Terms from "../Terms/Terms";
import Button from '@mui/material/Button';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Checkbox, TextField, FormControl, FormHelperText, InputLabel, OutlinedInput, InputAdornment, IconButton, FormGroup, FormControlLabel } from "@mui/material";
import Seo from "../../components/Seo";


export default function Register() {
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const[okToSubmit, setHideButtons] = useState(false)
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  const { style, setStyle } = useStyle();
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [passwordHelper, setPasswordHelper] = useState({ message: '', color: 'red' });
  const [confirmPasswordHelper, setConfirmPasswordHelper] = useState({ message: '', color: '' });
  const { setUser } = useContext(UserContext);
  const { isLoading,  } = useContext(UserContext);
  const { setUpdateFlag } = useContext(UserContext);

  const handleClickShowPassword1 = () => setShowPassword1((show) => !show);
  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);
  const handleMouseDownPassword = (event) => event.preventDefault();

  const [data, setData] = useState({
    email: '',
    password: '',
    password2: '',
    okToEmail: true,
  });

  const navToLogin = () => {
    navigate('/login');
  };

  const handlePasswordChange = (e) => {
    const password = e.target.value;
    setData({ ...data, password });

    if (password.length >= 6 && password.length > 0) {
      setPasswordHelper({ message: 'Password OK', color: 'green' });
    } else {
      setPasswordHelper({ message: 'Password must be 6 characters or more', color: 'red' });
    }
  };

  const checkIfOK = (e) => {

  }

  const handleConfirmPasswordChange = (e) => {
    const password2 = e.target.value;
    setData({ ...data, password2 });

    if(data.password.length < 1)
    {
        setConfirmPasswordHelper({message: '', color:'red'})
    }
    else if(password2.length < 1)
    {
        setConfirmPasswordHelper({message: '', color:'red'})
    }
    else if (password2 !== data.password) {
      setConfirmPasswordHelper({ message: 'Passwords do not match', color: 'red' });
    } else {
      setConfirmPasswordHelper({ message: 'Passwords match', color: 'green' });
    }
  };

  const registerUser = async (e) => {
    e.preventDefault();
    var okToSend = true;

    const { email, password, password2, okToEmail } = data;
   

    if (!email) {
      okToSend = false;
      toast.error("Error: You must enter your E-Mail address to create an account");
    }

    if (!password) {
      okToSend = false;
      toast.error("Error: Password cannot be blank");
    }

    if (!password2) {
      okToSend = false;
      toast.error("Error: Please enter your password again");
    }

    if (password !== password2) {
      okToSend = false;
      toast.error("Passwords do not match");
    }

    if (okToSend) {
      try {

        console.log("sending... ", email, "  " , password)

        const { data } = await axios.post('/register', { email, password, okToEmail });

        if (data.error) {
          toast.error(data.error);
        } else {
          setData({});

          const{data} = await axios.post('/login', {
            email, 
            password,
          });
          const userData = data;
          if(data.error){

            toast.error(data.error)
        }   else {            

            await setUser(userData);
            localStorage.setItem('token', data.token)
            toast.success(data.success)
            await setUpdateFlag()
            //window.location.href = `/`
    }



          toast.success('Registration Successful. Welcome!');
         window.location.href = `/`
        }

      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <>
    <Seo
      title="Create Account | Parish Audio"
      description="Create your Parish Audio account to manage purchases, downloads, subscriptions, and plugin access."
      canonical="https://parishaudio.com/register"
      robots="noindex,follow"
    />

      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: '25px'}}>
        <div style={{ display: 'flex', flexDirection: 'column', width: '90%', maxWidth: '600px', margin: 'auto', color: style.color4, textAlign: 'center', marginTop: '5px', backgroundColor: style.color1, borderRadius: '10px', borderStyle: 'solid', borderColor: style.color1, borderWidth: '5px', marginBottom:'25px' }}>
          <div style={{ width: '95%', margin: 'auto' }}>
            <div style={{ display: 'flex', flex: 1, textAlign: 'center', marginTop: '10px' }}>
              <h1 style={{ flex: 1, textAlign: 'center', margin: 'auto', marginBottom: '25px' }}>
                Create Your Account
              </h1>
            </div>
            <div style={{ maxWidth: '400px', margin: 'auto' }}>
              <div style={{ display: 'flex', flex: 1, textAlign: 'center', minWidth: '300px', margin: 'auto', marginBottom: '10px' }}>
                <h4 style={{ flex: 1, textAlign: 'left', margin: 'auto', color: style.color1 }}>
                  <div style={{  }}>
                    <TextField
                      id="outlined-basic"
                      label="Email"
                      variant="outlined"
                      value={data.email}
                      onChange={(e) => setData({ ...data, email: e.target.value })}
                      size='small'
                      fullWidth
                      sx={{
                        backgroundColor: style.color2,
                        borderRadius:'4px',
                        '& .MuiInputBase-input': {
                        color: style.color4,  // Change the font color here
                        fontSize: '14pt',  // Change the font size here
                        boxShadow:5,
                                                        
                        },
                        '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: style.color1, // Change the border color if needed
                            borderWidth:'2px'
                        },
                        '&:hover fieldset': {
                            borderColor: style.color1, // Change the border color on hover if needed\
                            borderWidth:'3px',                                                               
                     
                            
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: style.color1, // Change the border color when focused if needed
                            borderWidth:'3px'
                            
                        },
                        '&.Mui-disabled': {
                            '& fieldset': {
                            borderColor: style.color1, // Change the border color when disabled
                            },
                        },
                        },
                        '& .MuiInputLabel-root': {
                        color: style.color3, // Change the label color here
                        fontSize:'14pt',
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                        color: style.color3, // Change the label color when focused here                                 
                        },
                        '& .MuiInputLabel-root.Mui-disabled': {
                        color: style.color2, // Change the label color when disabled
                        },
                        '& .MuiInputBase-root.Mui-disabled': {
                        '& input': {
                            color: style.color3, // Change the input font color when disabled // so it works in safari
                            WebkitTextFillColor: style.color4, // so it works on chrome
                            fontSize:'14pt'
                        },
                        },
                        '& .MuiOutlinedInput-input': { color: style.color4,
                        '&:-webkit-autofill': { WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset',
                            WebkitTextFillColor: style.color4, color:style.color4
                         }, }, 
                    }}
                    />
                  </div>
                </h4>
              </div>

              <div style={{ display: 'flex', flex: 1, flexDirection:'column', marginBottom: '10px', width: '100%', backgroundColor:style.color1}}>
              <FormControl sx={{
                  backgroundColor: style.color2,
                  flex: 1,
                  width:'100%',
                  size: 'small',
                  margin: 'auto',
                  boxShadow:5,

                  

                  '& .MuiInputBase-input': {
                    color: style.color3,
                    fontSize: '14pt',
                    size: 'small',
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: style.color1,
                      borderWidth: '2px'
                    },
                    '&:hover fieldset': {
                      borderColor: style.color2,
                      borderWidth: '3px',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: style.color2,
                      borderWidth: '3px',
                    },
                    '&.Mui-disabled': {
                      '& fieldset': {
                        borderColor: style.color1,
                      },
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color: style.color3,
                    fontSize: '14pt',
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: style.color3,
                  },
                  '& .MuiInputLabel-root.Mui-disabled': {
                    color: style.color3,
                  },
                  '& .MuiInputBase-root.Mui-disabled': {
                    '& input': {
                      color: style.color3,
                      WebkitTextFillColor: style.color1,
                      fontSize: '14pt'
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    color: style.color4,
                    '& input:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset !important',
                    WebkitTextFillColor: `${style.color4} !important`,
                    color: `${style.color4} !important`,
                    caretColor: `${style.color4} !important`,
                },
                  },
                }} variant="outlined">
                  <InputLabel size="small" htmlFor="outlined-adornment-password">Password</InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword1 ? 'text' : 'password'}
                    value={data.password}
                    size='small'
                    onChange={handlePasswordChange}
                    sx={{
                        '& input:-webkit-autofill': {
                        WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset !important',
                        WebkitTextFillColor: `${style.color4} !important`,
                        color: `${style.color4} !important`,
                        caretColor: `${style.color4} !important`,
                    },
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword1}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          sx={{ color: style.color1 }}
                        >
                          {showPassword1 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Password"
                  />
  
                 </FormControl>
          
                {/* <FormControl sx={{
                  backgroundColor: style.color2,
                  flex: 1,
                  width:'100%',
                  size: 'small',
                  margin: 'auto',
                  '& .MuiInputBase-input': {
                    color: style.color3,
                    fontSize: '14pt',
                    size: 'small',
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: style.color1,
                      borderWidth: '2px'
                    },
                    '&:hover fieldset': {
                      borderColor: style.color2,
                      borderWidth: '3px',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: style.color2,
                      borderWidth: '3px',
                    },
                    '&.Mui-disabled': {
                      '& fieldset': {
                        borderColor: style.color1,
                      },
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color: style.color3,
                    fontSize: '14pt',
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: style.color3,
                  },
                  '& .MuiInputLabel-root.Mui-disabled': {
                    color: style.color3,
                  },
                  '& .MuiInputBase-root.Mui-disabled': {
                    '& input': {
                      color: style.color3,
                      WebkitTextFillColor: style.color1,
                      fontSize: '14pt'
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    color: style.color4,
                    '&:-webkit-autofill': {
                      WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset !important',
                      WebkitTextFillColor: `${style.color4} !important`,
                      color: `${style.color4} !important`,
                      caretColor: `${style.color4} !important`,
                    },
                  },
                }} variant="outlined">
                  <InputLabel size="small" htmlFor="outlined-adornment-password">Password</InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword1 ? 'text' : 'password'}
                    value={data.password}
                    size='small'
                    sx={{
                      '& input:-webkit-autofill': {
                      WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset !important',
                      WebkitTextFillColor: `${style.color4} !important`,
                      color: `${style.color4} !important`,
                      caretColor: `${style.color4} !important`,
                  },
                  }}
                    onChange={handlePasswordChange}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword1}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          sx={{ color: style.color1 }}
                        >
                          {showPassword1 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Password"
                  />
  
                 </FormControl> */}

                    <FormHelperText sx={{ color: passwordHelper.color, backgroundColor:style.color1, fontSize: '12pt', width:'100%' }}>
                        {passwordHelper.message}
                  </FormHelperText>
              </div>

              <div style={{ display: 'flex', flex: 1, flexDirection:'column', marginBottom: '20px', width: '100%', backgroundColor:style.color1  }}>
              <FormControl sx={{
                  backgroundColor: style.color2,
                  flex: 1,
                  width:'100%',
                  size: 'small',
                  margin: 'auto',
                  boxShadow:5,

                  

                  '& .MuiInputBase-input': {
                    color: style.color3,
                    fontSize: '14pt',
                    size: 'small',
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: style.color1,
                      borderWidth: '2px'
                    },
                    '&:hover fieldset': {
                      borderColor: style.color2,
                      borderWidth: '3px',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: style.color2,
                      borderWidth: '3px',
                    },
                    '&.Mui-disabled': {
                      '& fieldset': {
                        borderColor: style.color1,
                      },
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color: style.color3,
                    fontSize: '14pt',
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: style.color3,
                  },
                  '& .MuiInputLabel-root.Mui-disabled': {
                    color: style.color3,
                  },
                  '& .MuiInputBase-root.Mui-disabled': {
                    '& input': {
                      color: style.color3,
                      WebkitTextFillColor: style.color1,
                      fontSize: '14pt'
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    color: style.color4,
                    '& input:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset !important',
                    WebkitTextFillColor: `${style.color4} !important`,
                    color: `${style.color4} !important`,
                    caretColor: `${style.color4} !important`,
                },
                  },
                }} variant="outlined">
                  <InputLabel size="small" htmlFor="outlined-adornment-password">Password</InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword2 ? 'text' : 'password'}
                    value={data.password2}
                    size='small'
                    onChange={handleConfirmPasswordChange}
                    sx={{
                        '& input:-webkit-autofill': {
                        WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset !important',
                        WebkitTextFillColor: `${style.color4} !important`,
                        color: `${style.color4} !important`,
                        caretColor: `${style.color4} !important`,
                    },
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword2}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          sx={{ color: style.color1 }}
                        >
                          {showPassword2 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Password Again"
                  />
  
                 </FormControl>
        
                {/* <FormControl sx={{
                  backgroundColor: style.color2,
                  flex: 1,
                  width:'100%',
                  size: 'small',
                  margin: 'auto',
                  '& .MuiInputBase-input': {
                    color: style.color3,
                    fontSize: '14pt',
                    size: 'small',
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: style.color1,
                      borderWidth: '2px'
                    },
                    '&:hover fieldset': {
                      borderColor: style.color2,
                      borderWidth: '3px',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: style.color2,
                      borderWidth: '3px',
                    },
                    '&.Mui-disabled': {
                      '& fieldset': {
                        borderColor: style.color1,
                      },
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color: style.color3,
                    fontSize: '14pt',
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: style.color3,
                  },
                  '& .MuiInputLabel-root.Mui-disabled': {
                    color: style.color3,
                  },
                  '& .MuiInputBase-root.Mui-disabled': {
                    '& input': {
                      color: style.color3,
                      WebkitTextFillColor: style.color1,
                      fontSize: '14pt'
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    color: style.color4,
                    '&:-webkit-autofill': {
                      WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset !important',
                      WebkitTextFillColor: `${style.color4} !important`,
                      color: `${style.color4} !important`,
                      caretColor: `${style.color4} !important`,
                    },
                  },
                }} variant="outlined">
                  <InputLabel size="small" htmlFor="outlined-adornment-password">Password Again</InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword2 ? 'text' : 'password'}
                    value={data.password2}
                    size='small'
                    onChange={handleConfirmPasswordChange}
                    sx={{
                      '& input:-webkit-autofill': {
                      WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset !important',
                      WebkitTextFillColor: `${style.color4} !important`,
                      color: `${style.color4} !important`,
                      caretColor: `${style.color4} !important`,
                  },
                  }}

                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword2}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          sx={{ color: style.color1 }}
                        >
                          {showPassword2 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Password Again"
                  />
                </FormControl> */}
                <FormHelperText sx={{ color: confirmPasswordHelper.color, backgroundColor:style.color1, fontSize: '12pt' }}>
                    {confirmPasswordHelper.message}
                  </FormHelperText>

                  {/* <FormGroup>
                    <FormControlLabel checked={data.okToEmail} onChange={(e) => setData({ ...data, okToEmail: e.target.checked }) } control={<Checkbox size='large' sx={{color:style.color1, '&.Mui-checked': {
                        color: style.color1,
                    },}} />} label="Subscribe to Emails" />
                </FormGroup> */}
              </div>


              
                <div style={{ marginTop: '25px', marginBottom: '30px', display: 'flex', flex: 1 }}>
                  <Button onClick={registerUser} sx={{ my: 2, color: style.color4, display: 'block', backgroundColor: style.color1, filter: 'brightness(1.1)', boxShadow:5,fontSize: '14pt', width: '75%', minWidth: '250px', margin: 'auto', marginTop: '0px', borderColor: style.color2, borderWidth: '1px', borderStyle: 'solid', '&:hover': { backgroundColor: style.color2 }, }}>Create Account</Button>
                </div>
              
              {/* {(data.password.length < 6 || data.password != data.password2) && (
                <div style={{ marginTop: '50px', marginBottom: '50px', display: 'flex', flex: 1 }}>
                  <Button disabled onClick={registerUser} sx={{ my: 2, color: style.color5, display: 'block', backgroundColor: style.color3, fontSize: '16pt', width: '100%', minWidth: '250px', margin: 'auto', marginTop: '0px', borderColor: style.color4, borderWidth: '2px', borderStyle: 'solid', '&:hover': { backgroundColor: style.color4 }, }}>Create Account</Button>
                </div>
              )} */}

              <div style={{ marginBottom: '20px' }}>
                <h4 style={{marginBottom:'10px'}}>Already have an account?</h4>
                <Button onClick={navToLogin} sx={{ my: 2, color: style.color3, display: 'block', margin: 'auto', boxShadow:5,backgroundColor: style.color1, filter: 'brightness(1.1)', fontSize: '12pt', width: '75%', minWidth: '150px', margin: 'auto', marginTop: '0px', borderColor: style.color2, borderWidth: '1px', borderStyle: 'solid', '&:hover': { backgroundColor: style.color2 } }}>
                  <strong>Login</strong>
                </Button>
              </div>
              <div style={{ flex: 1, borderBottomLeftRadius: '15px', color: style.color5, marginBottom: '25px' }}>
                By using this website, you agree to our
                <div>
                  <Button sx={{ my: 2, color: style.color3, display: 'block', margin: 'auto', backgroundColor: style.color1, fontSize: '12pt', width: '100%', minWidth: '250px', margin: 'auto', marginTop: '0px', borderColor: style.color1, borderWidth: '2px', borderStyle: 'solid', '&:hover': { backgroundColor: style.color1, color:style.color4 } }} onClick={setModalOpen.bind(null, true)}><strong>terms and conditions</strong></Button>
                </div>
              </div>

              <div id='modal-root'>
                <TermsModal isOpen={isModalOpen} close={closeModal}>
                  <Terms />
                </TermsModal>
              </div>
            </div>
          </div>
        </div>
        <div id='modal-root'></div>
      </div>
    </>
  );
}




